import { PersonalAvatarVoice } from '@/api/personal-avatars';
import { AI_SOURCES } from '@/constants/api';

export enum AvatarType {
  Default = 'DEFAULT',
  Personal = 'PERSONAL',
  BunuPersonal = 'BUNU_PERSONAL',
}

type AvatarFitSettings =
  | { type: 'contain' | 'cover' }
  | {
      type: 'crop';
      crop: { x: number; y: number; width: number; height: number };
    };

export enum AvatarGender {
  Male = 'male',
  Female = 'female',
}

type AvatarMetadata = {
  ageRange?: '1-19' | '20-29' | '30-39' | '40-49' | '50-59' | '60+';
  clothingStyle?: 'formal' | 'casual' | 'business casual' | 'traditional';
  clothingColorPalette?: string[];
  gender?: AvatarGender;
  background?: 'office' | 'outdoor' | 'home' | 'studio' | 'indoor' | 'other';
};

interface BaseAvatar {
  id: string;
  src: string;
  posterSrc?: string;
  videoPreviewSrc?: string;
  name: string;
  source: AI_SOURCES;
  disabled?: boolean;
  approvedForAds?: boolean;
  type: AvatarType;
  fullscreenFit: AvatarFitSettings;
  circleFit: AvatarFitSettings;
  avatarId: string;
  metadata?: AvatarMetadata;
  hardcoded?: boolean;

  sources?: {
    no_bg?: string;
    video_preview_no_bg?: string;
  };
}

interface SynthesiaAvatar extends BaseAvatar {
  source: AI_SOURCES.synthesia;
  voiceId: string;
}

interface TavusAvatar extends BaseAvatar {
  source: AI_SOURCES.tavus;
}

interface BunuPersonalAvatar extends Omit<BaseAvatar, 'circleFit'> {
  source: AI_SOURCES.personal_avatar;
  type: AvatarType.BunuPersonal;
  bunuAvatarConfig: {
    avatarId: string;
    appKey: string;
    voice: PersonalAvatarVoice;
    avatarImageUrl: string;
  };
}

export type Avatar = SynthesiaAvatar | TavusAvatar | BunuPersonalAvatar;

export enum PersonalAvatarStatus {
  PROCESSING = 'PROCESSING',
  DONE = 'DONE',
  FAILED = 'FAILED',
}
